import { useState, useRef, useEffect } from 'react'
import { inject, observer } from 'mobx-react';
import { CommonService, UserService } from "../../services";
import { createMultipleRef, validateInput, getValueInputRef, setOptions } from '../../helpers'
import { Card, Modal, Button, Input, InputPassword, ModalAlert, Select, FormLoading, ExportExcel } from '../../components'
import DataGrid, { SearchPanel, Toolbar, Item, Paging, Pager, Column, HeaderFilter } from 'devextreme-react/data-grid';
import { PlusIcon, RefreshIcon, CheckIcon } from '@heroicons/react/outline';
import { LockOutlined, CheckCircleOutlined, CustomerServiceOutlined } from "@ant-design/icons";
import { isEmpty } from 'lodash'
import { useTranslation } from 'react-i18next'
import './style.css'
import RegisterPlan from './RegisterPlan'
import RegisterForm from './RegisterForm'

let firstRender = false
const Register = inject("authenStore")(observer((props) => {
  const { t } = useTranslation(['register', 'common'])
  let authenStore = props.authenStore
  let { getAccountAuth } = authenStore // STATE
  let auth = { action_user_id: getAccountAuth?.user_id, token_id: getAccountAuth?.access_token }

  const [billing, setBilling] = useState("monthly")
  const [action, setAction] = useState("plan") // plan|register

  const [optionAlert, setOptionAlert]: any = useState({
    show: false,
    action: {
      id: "",
      name: ""
    },
    type: "success",
    title: "",
    description: {
      visible: false,
      type: "",
      content: "",
      contentLists: []
    }
  })

  const [dataForm, setDataForm]: any = useState({
    "id": "",
    "employee_code": "",
    "username": "",
    "password": "",
    "first_name": "",
    "last_name": "",
    "email": "",
    "phone_no": "",
    "position": "",
    "user_status": "Y",
    "user_group_id": "",
    "role_level": ""
  })


  return (
    <>
      <Card>
        {
          action === 'plan' ? <RegisterPlan onNext={() => setAction("register")} /> : <RegisterForm onBack={() => setAction("plan")} />
        }

      </Card>
    </>
  )
}))

export default Register